import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { ModalClose } from 'builder/components/ModalClose'

export const ModalContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 544px;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S};
`

export const ModalContent = styled.div`
  display: flex;
  flex-flow: column;
  padding: ${Spacing.L};
  gap: ${Spacing.XS};
`

export const ModalHeader = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const Heading = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
`

export const SubHeading = styled.div`
  color: ${Colors.Neutral50};
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  justify-content: flex-end;
  margin-top: ${Spacing.M};
`

export const Close = styled(ModalClose)``
